import ChatBotAvatar from '@/components/Chat/ChatBotAvatar';
import { displayChatTitle } from '@/lib/chatTitle';
import React from 'react';
import { Link, useRouter } from 'expo-router';
import Text from '@/components/Typography/Text';
import ListItem from '@/components/ListItem';

export default function ChatDetailedItem({
  title,
  agentId,
  messages = [],
  href,
  isLastItem,
}) {
  const lastMessage = Array.isArray(messages) && messages.length > 0 ? messages[messages.length - 1] : null;
  const lastMessageContent = lastMessage?.content || 'No messages';
  const router = useRouter();

  return (
    <ListItem
      isBordered
      isLastItem={isLastItem}
      title={displayChatTitle(title)}
      leading={<ChatBotAvatar agentId={agentId} />}
      onPress={() => {
        if (href) {
          router.push(href);
        }
      }}
      subtitle={lastMessage && (
        <Text size='n' color='secondary' numberOfLines={1} style={{lineHeight: 20}}>
          {lastMessageContent}
        </Text>
      )}
    />
  )
} 